<template>
  <!-- 休日出勤管理詳細画面 -->
  <CCard>
    <CCardHeader>
      <h2>休日出勤詳細</h2>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <div class="container">
          <table class="table">
            <tr>
              <th scope="row">申請日</th>
              <td>{{ updated_at }}</td>
            </tr>
            <tr>
              <th scope="row">日付</th>
              <td><span>{{ formatDate(holiday_work_date) }}</span></td>
            </tr>
            <tr>
              <th scope="row">開始予定時間</th>
              <td><span>{{ start_time }}</span></td>
            </tr>
            <tr>
              <th scope="row">終了予定時間</th>
              <td><span>{{ end_time }}</span></td>
            </tr>
              <tr>
              <th scope="row">発生理由</th>
              <td><span>{{ reason }}</span></td>
            </tr>
          </table>
          <CRow class="mt-3 align-items-center">
              <CCol class="text-start">
                <router-link :to="{ name: holidayWorksList }">
                  <button class="btn btn-secondary">戻る</button>
                </router-link>
              </CCol>
              <CCol class="text-center">
                <router-link
                  :to="{
                    name: holidayWorksEdit,
                    params: { value: $route.params.value },
                  }"
                >
                  <button class="btn btn-info">編集</button>
                </router-link>
              </CCol>
              <CCol></CCol>
            </CRow>
        </div>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import ConstList from "./../../ConstList";
import axios from "axios";
export default {
  name: "Info",
  data() {
    return {
      holiday_work_date: "",
      start_time: "",
      end_time: "",
      reason: "",
      updated_at: "",
      holidayWorksList: "",
      holidayWorksEdit: "",
    };
  },

  created() {
    this.holidayWorksList = ConstList.ROUTE_HOLIDAYWORKS_LIST;
    this.holidayWorksEdit = ConstList.ROUTE_HOLIDAYWORKS_EDIT;
  },  

  methods: { 
    formatDate(dateStr) {
      // yyyy/mm/ddフォーマット変換
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },

  // DBから各種情報を取得
  mounted: function () {
    this.id = this.$route.params.id;
    const id = parseInt(this.id);
    axios
      .get(process.env.VUE_APP_API_ORIGIN + "/holidayWork/" + id)
      .then((response) => {
        if (response.data.length === 0) {
          this.errors.push(ConstList.EMPTY);
        }
        const holidayWorkData = response.data;
        this.holiday_work_date = holidayWorkData.date;
        // 秒が付いてくる場合は「時:分」だけに整形
        this.start_time = holidayWorkData.start_time
          ? holidayWorkData.start_time.substring(0, 5)
          : "";
        this.end_time = holidayWorkData.end_time
          ? holidayWorkData.end_time.substring(0, 5)
          : "";
        this.reason = holidayWorkData.reason;
        this.updated_at = holidayWorkData.updated_at;
      })
      .catch((error) => {
        axios
        .get(
          `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
        )
        .then(() => {
          alert(ConstList.SYSTEM_ERROR);
        })
        .catch(() => {
          alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
        });
      });
  },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
.custom-time-input {
  width: 120px;
  height: 35px;
}
.container {
  margin-left: 0%;
}
</style>
